import PastJobDescriptions from './PastDescriptions';

export default PastJobDescriptions;
